export default "__VITE_ASSET__CQNzuXcr__"